import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { PublicOutlined as GlobalScopeIcon } from '@mui/icons-material';

// Read-only header chip that names the effective data scope on pages where a
// society selector would be misleading (e.g. platform-global pages). Replaces
// the selector so the operator sees the scope instead of a dangerous control.
const ScopeChip = ({
  label = 'Global scope',
  tooltip = 'This page shows platform-wide data across all societies. It is not scoped to a single society.',
  icon,
}) => {
  return (
    <Tooltip title={tooltip}>
      <Chip
        icon={icon || <GlobalScopeIcon fontSize="small" />}
        label={label}
        size="small"
        variant="outlined"
        aria-label={`Data scope: ${label}`}
        sx={{
          height: 40,
          borderRadius: 2,
          px: 0.5,
          fontSize: 14,
          fontWeight: 600,
          color: 'text.primary',
          bgcolor: 'background.paper',
          borderColor: 'divider',
          '& .MuiChip-icon': { color: 'text.secondary' },
        }}
      />
    </Tooltip>
  );
};

export default ScopeChip;
